import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class CustomerApprovedExpenseReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/customer-approved-expenses-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Customer Approved Expense Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let invoicedJobs = [];
        const {selectedCustomers} = this.state;
        let downloadableCsvDataInvoiced = "JOB REF, REG/VIN, CUSTOMER, MILES, JOB PRICE, DRIVER PRICE, EXPENSE TYPE, EXPENSES APP, PROFIT MARGIN\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let expense_price = 0.00;
                let toll_road = parseFloat((currentJob.toll_road/100).toFixed(2));
                let travel = parseFloat((currentJob.travel/100).toFixed(2));
                let hotel = parseFloat((currentJob.hotel/100).toFixed(2));
                let fuel_price = parseFloat((currentJob.expenses_approval_fuel_total/100).toFixed(2));
                let jobTotalPrice = parseFloat(currentJob.job_price);


                if (currentJob.fuel_included_in_job_price === 1) {
                    expense_price = ((fuel_price) + (toll_road) + (travel) + (hotel));
                } else {
                    expense_price = ((toll_road) + (travel) + (hotel));
                }
                let dPrice = parseFloat(currentJob.driver_price);
                let adminFPrice = (currentJob.admin_fee_in_pence) ? (parseFloat(currentJob.admin_fee_in_pence)) / 100 : 0.00;

                let jobProfitPlus = ((adminFPrice) + (dPrice) + (expense_price));
                let jobProfit = ((jobTotalPrice) - (jobProfitPlus));
                jobProfit = parseFloat(jobProfit).toFixed(2);

                let joburl = "/jobs/view/"+currentJob.id;
                let expenses_approval_price = parseFloat(currentJob.expenses_approval_price).toFixed(2);
                let expenses_approval_fuel_total = parseFloat(currentJob.expenses_approval_fuel_total).toFixed(2);
                let totalPrice = parseFloat(currentJob.job_price) + parseFloat(expenses_approval_price);
                totalPrice = parseFloat(totalPrice).toFixed(2);
                
                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                        <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>
                        <td>{currentJob.customer.name}</td>
                        <td>{currentJob.distance_in_miles}</td>
                        <td>&pound;{currentJob.job_price}</td>
                        <td>&pound;{currentJob.driver_price}</td>
                        <td>{currentJob.expense_type}</td>
                        <td>&pound;{expenses_approval_price}</td> 
                        <td>&pound;{jobProfit}</td> 
                    </tr>
            );
            var pickupAddress = ((currentJob.pickup_address)&&(currentJob.pickup_address.address_line_1))?currentJob.pickup_address.address_line_1:'';
            var dropAddress = ((currentJob.dropoff_address)&&(currentJob.dropoff_address.address_line_1))?currentJob.dropoff_address.address_line_1:'';

            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                            currentJob.id+','+
                                            currentJob.vehicle.registration_number+','+
                                            currentJob.customer.name+','+
                                            currentJob.distance_in_miles+','+
                                            currentJob.job_price+','+
                                            currentJob.driver_price+','+
                                            currentJob.expense_type+','+
                                            expenses_approval_price+','+
                                            jobProfit+','+
                                            ''+"\n";
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Customer Approved Expense Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Customer Approved Expense Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Customer Approved Expense Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>Miles</th>
                                        <th>Job price</th>
                                        <th>Driver price</th>
                                        <th>Expense Type</th>
                                        <th>Expenses App</th>
                                        <th>Profit Margin</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="26"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-customer_approved_expense_report')) {
    ReactDOM.render(
        <CustomerApprovedExpenseReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-customer_approved_expense_report')
    );
}
